import { render, staticRenderFns } from "./SelectJenisSetoran.vue?vue&type=template&id=430a245f&lang=pug"
import script from "./SelectJenisSetoran.vue?vue&type=script&lang=js"
export * from "./SelectJenisSetoran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports